export const CLOSE_MODAL = 'CLOSE_MODAL';

export const OPEN_MODAL = 'OPEN_MODAL';
